
  export default {
    name: `AeqInputSearcherField`,
    props: {
      label: {
        type: String,
        default: ``
      },
      searchUrl: {
        type: String,
        default: ``
      },
      value: {
        type: Object,
        default: undefined
      },
      hint: {
        type: String,
        default: ``
      },
      errorMessages: {
        type: [String, Array],
        default: () => []
      }
    },
    data() {
      return {
        focused: false,
        innerValue: this.value,
        queryValue: ``,
        showModal: false,
        selectedBox: null,
        selectedResult: this.value || { name: ``, value: ``, search: `` },
        loading: false,
        showResults: false,
        filteredProps: {},
        searchTimeout: null
      }
    },
    computed: {
      results() {
        const res = this.$store.getters[`inputSearcher/results`] || []
        return res.slice(0, 20)
      },
      shouldShowResults() {
        return !this.loading && this.showResults
      },
      isDisabled() {
        return this.filteredProps?.disabled || false
      }
    },
    mounted() {
      const parentObject = { $props: {} }
      this.filteredProps = Object.assign(parentObject.$props, this.$attrs)
      this.filteredProps.label = this.label
    },
    methods: {
      openModal() {
        this.$store.commit(`inputSearcher/setResults`, [])
        this.showModal = true
        this.showResults = false
      },
      closeModal() {
        this.showModal = false
      },
      submitValue() {
        this.selectedResult = { name: ``, value: ``, search: `` }
        const resultName = this.results.find((r) => r.value === this.selectedBox)
        if (resultName) {
          this.selectedResult.value = this.selectedBox
          this.selectedResult.name = resultName.name
          this.selectedResult.search = this.queryValue
        }
        this.closeModal()
        this.$emit(`input`, this.selectedResult)
      },
      onInput() {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout)
        }
        this.searchTimeout = setTimeout(() => {
          this.search()
        }, 500)
      },
      async search() {
        this.loading = true
        await this.$store.dispatch(`inputSearcher/getResults`, {
          url: this.searchUrl,
          query: this.queryValue
        })
        this.loading = false
        this.showResults = true
      }
    }
  }
